import React from 'react';
// @ts-ignore
import styles from './NoDataPlaceholder.module.scss';
import Text from '../Base/Text/Text';

interface NoDataPlaceholderProps {
	tx: String;
}

const NoDataPlaceholder: React.FC<NoDataPlaceholderProps> = props => {
	const { tx } = props;

	return (
		<div className={styles.wrapper}>
			<Text tx={tx} className={styles.text} />
		</div>
	);
};

export default NoDataPlaceholder;
